// extracted by mini-css-extract-plugin
module.exports = {"grid":"style__grid__w6CUw","desc":"style__desc__8NJl7","comment":"style__comment__G9jOQ"};